import { render } from "./template.vue?vue&type=template&id=4db427b4&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=4db427b4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db427b4"]])

export default __exports__